import React, { useEffect } from 'react';
import '../.././styles/alumni.scss';
import { saveCookies } from '../../hooks';
import InvalidLinkContentView from './InvalidLinkContentView';
import Footer from './Footer';
import { recordEvent } from 'src/analytics/amplify';

function InvalidLinkScreen() {
    saveCookies();
    useEffect(() => {
        recordEvent({
            name: 'InvalidLinkScreen.Render'
        });
    }, []);

    return(
        <div className="fullscreen">
            <div className="activation-flow-flex-container">
                <div data-testid="invalidLinkBackground" className="flex-box-left-badge-background">
                </div>
                <div className="flex-box-right">
                    <div data-testid="invalidLinkContent" className="alumni-error-page-content-wrap">
                        < InvalidLinkContentView />
                    </div>
                    <div data-testid="footer" className="footer-container">
                        <Footer screen="InvalidLinkScreen"/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InvalidLinkScreen;
